import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchQualifications } from 'store/qualification/qualificationActions';
import QualificationSelect from './QualificationSelect';

class QualificationSelectContainer extends React.Component {
    componentDidMount() {
        this.props.fetchQualifications();
    }

    render() {
        const { qualifications, categorieId, value, isLoading, onChange, error, isRequired, noLabel, disabled, afficheAide } = this.props;

        let filteredQualifications = qualifications.filter(q => q.categorieId === categorieId && !q.desactiveCreation);

        return (
            <QualificationSelect
                qualifications={filteredQualifications}
                value={value}
                isLoading={isLoading}
                onChange={onChange}
                isRequired={isRequired}
                error={error}
                noLabel={noLabel}
                disabled={disabled}
                afficheAide={afficheAide}
            />
        );
    }
}

const mapStateToProps = state => ({
    qualifications: state.qualification.qualifications.items,
    isLoading: state.qualification.qualifications.isLoading
});

const mapDispatchToProps = dispatch => ({
    fetchQualifications: () => dispatch(fetchQualifications(false))
});

QualificationSelectContainer.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    categorieId: PropTypes.number.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    noLabel: PropTypes.bool,
    disabled: PropTypes.bool,
    afficheAide: PropTypes.bool
};

QualificationSelectContainer.defaultProps = {
    disabled: false,
    afficheAide: false
};

export default connect(mapStateToProps, mapDispatchToProps)(QualificationSelectContainer);